export default __webpack_public_path__ + "static/media/dining.600d6224.png";